import { render } from "./App.vue?vue&type=template&id=675d268e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@/assets/css/bootstrap.css?vue&type=style&index=0&lang=css&external"
import "@/assets/css/global.css?vue&type=style&index=1&lang=css&external"
import "./App.vue?vue&type=style&index=2&id=675d268e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__